export default __webpack_public_path__ + "static/media/promomodalnbabg.14eb377c.png";